export default "__VITE_ASSET__BLiaTMov__"